import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { useLang } from '../i18n/LanguageContext';

export default function CookieConsent() {
  const { t } = useLang();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem('gyeno_cookie_consent')) {
      const timer = setTimeout(() => setVisible(true), 1600);
      return () => clearTimeout(timer);
    }
  }, []);

  const decide = (value) => {
    localStorage.setItem('gyeno_cookie_consent', value);
    setVisible(false);
    if (value === 'all') {
      window.dispatchEvent(new Event('gyeno-analytics-consent'));
    }
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ opacity: 0, y: 60 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 60 }}
          transition={{ duration: 0.45, ease: [0.22, 1, 0.36, 1] }}
          className="fixed bottom-5 left-5 right-5 sm:right-auto sm:max-w-md z-[70]"
          data-testid="cookie-consent-banner"
        >
          <div className="rounded-2xl bg-[#10282C] text-white p-5 shadow-2xl border border-[#00C5C2]/20">
            <p className="text-[13px] leading-relaxed text-white/80">
              {t('cookie.text')}{' '}
              <Link to="/privacy" data-testid="cookie-privacy-link" className="text-[#00C5C2] underline underline-offset-2">{t('footer.privacy')}</Link>.
            </p>
            <div className="mt-4 flex gap-2.5">
              <button
                data-testid="cookie-accept-btn"
                onClick={() => decide('all')}
                className="btn-teal px-4 py-2 rounded-full text-[13px] font-semibold"
              >
                {t('cookie.accept')}
              </button>
              <button
                data-testid="cookie-reject-btn"
                onClick={() => decide('essential')}
                className="btn-ghost-dark px-4 py-2 rounded-full text-[13px] font-medium"
              >
                {t('cookie.reject')}
              </button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
